enum Tags {
  DEFAULT = 'default',
  SUCCESS = 'success',
  ERROR = 'error',
}

export {
  Tags,
};
